var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 72,
    viewBox: "0 0 77 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 3.58172 9.58172 0 14 0H62C66.4183 0 70 3.58172 70 8V56C70 60.4183 66.4183 64 62 64H14C9.58172 64 6 60.4183 6 56V8Z",
    fill: "url(#paint0_linear_368_11)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_368_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7393 20.7529L4.00592 19.1018C4.00592 19.1018 3.62845 26.1096 8.90083 26.5255C14.1732 26.9413 21.0042 27.4672 21.0042 27.4672L26.7393 20.7529Z",
    fill: "url(#paint1_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1914 21.0587L4.35909 19.4565C4.35909 19.4565 4.06686 25.6205 8.73042 26.2198C13.3331 26.8068 21.0164 27.1248 21.0164 27.1248L26.1914 21.0587Z",
    fill: "url(#paint2_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.488 27.6017L8.7547 25.9629C8.7547 25.9629 8.37723 32.9707 13.6496 33.3865C18.922 33.8024 25.753 34.3283 25.753 34.3283L31.488 27.6017Z",
    fill: "url(#paint3_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9279 27.9198L9.09567 26.3054C9.09567 26.3054 8.80343 32.4694 13.467 33.0687C18.0697 33.6557 25.753 33.9737 25.753 33.9737L30.9279 27.9198Z",
    fill: "url(#paint4_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0205 20.166L72.7417 18.5149C72.7417 18.5149 73.1191 25.5227 67.8468 25.9385C62.5744 26.3544 55.7434 26.8803 55.7434 26.8803L50.0205 20.166Z",
    fill: "url(#paint5_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5685 20.4718L72.4008 18.8696C72.4008 18.8696 72.693 25.0336 68.0294 25.6329C63.4268 26.2199 55.7435 26.5379 55.7435 26.5379L50.5685 20.4718Z",
    fill: "url(#paint6_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2717 27.027L68.0051 25.376C68.0051 25.376 68.3825 32.3838 63.1102 32.7996C57.8378 33.2155 51.0068 33.7413 51.0068 33.7413L45.2717 27.027Z",
    fill: "url(#paint7_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8318 27.3329L67.6641 25.7307C67.6641 25.7307 67.9563 31.8947 63.2927 32.4939C58.6901 33.081 51.0068 33.399 51.0068 33.399L45.8318 27.3329Z",
    fill: "url(#paint8_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.608 45.7145L41.8258 54.3612C39.8898 55.4986 37.491 55.4986 35.5428 54.3612L20.7607 45.7145C18.849 44.5893 17.6678 42.5347 17.6678 40.3088V22.9176C17.6678 20.6918 18.849 18.6249 20.7607 17.5119L35.555 8.85305C37.491 7.71565 39.8898 7.71565 41.838 8.85305L56.608 17.4997C58.5197 18.6249 59.7008 20.6795 59.7008 22.9054V40.2966C59.713 42.5347 58.5318 44.5893 56.608 45.7145Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9976 43.99L39.8045 53.8474C39.1104 54.251 38.2581 54.251 37.564 53.8474L20.371 43.99C19.6769 43.5864 19.2507 42.8526 19.2507 42.0576V22.3305C19.2507 21.5356 19.6769 20.8018 20.371 20.3982L37.564 10.5407C38.2581 10.1371 39.1104 10.1371 39.8045 10.5407L56.9976 20.3982C57.6916 20.8018 58.1178 21.5356 58.1178 22.3305V42.0576C58.1178 42.8526 57.6916 43.5986 56.9976 43.99Z",
    fill: "url(#paint9_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9261 43.1951L39.8776 52.4043C39.2323 52.7712 38.4286 52.7712 37.7833 52.4043L21.7348 43.1951C21.0894 42.8282 20.6876 42.1433 20.6876 41.3973V22.9788C20.6876 22.2327 21.0894 21.5479 21.7348 21.181L37.7833 11.9717C38.4286 11.6048 39.2323 11.6048 39.8776 11.9717L55.9261 21.181C56.5715 21.5479 56.9733 22.2327 56.9733 22.9788V41.3973C56.9733 42.1311 56.5715 42.8282 55.9261 43.1951Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1818 43.0361L39.147 52.9058C38.9643 53.0036 38.7452 53.0036 38.5747 52.9058L21.5399 43.0361C21.3573 42.9383 21.2477 42.7426 21.2477 42.5347V22.7831C21.2477 22.5752 21.3573 22.3795 21.5399 22.2817L38.5747 12.412C38.7573 12.3142 38.9765 12.3142 39.147 12.412L56.1818 22.2817C56.3644 22.3795 56.474 22.5752 56.474 22.7831V42.5225C56.474 42.7304 56.3644 42.926 56.1818 43.0361Z",
    fill: "url(#paint10_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M38.8548 52.331C38.5991 52.331 38.3555 52.2698 38.1242 52.1353L22.4897 42.9016C22.0513 42.6447 21.7834 42.1678 21.7834 41.6663V23.15C21.7834 22.6486 22.0513 22.1716 22.4897 21.9148L38.1242 12.681C38.5747 12.412 39.1226 12.412 39.5732 12.681L55.2077 21.9148C55.646 22.1716 55.9139 22.6486 55.9139 23.15V41.6419C55.9139 42.1433 55.646 42.6203 55.2077 42.8771L39.5732 52.1108C39.354 52.2576 39.1105 52.331 38.8548 52.331ZM23.5003 41.4951L38.8548 50.5698L54.2092 41.4951V23.309L38.8548 14.2343L23.5003 23.309V41.4951Z",
    fill: "#8774F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7208 53.1382C38.2459 53.1382 37.771 53.0159 37.3449 52.7713L21.7347 43.6476C20.8946 43.1584 20.371 42.2534 20.371 41.275V23.0033C20.371 22.0249 20.8946 21.1198 21.7347 20.6306L37.3449 11.507C38.1972 11.0178 39.2444 11.0056 40.0967 11.507L55.7069 20.6306C56.5471 21.1198 57.0706 22.0249 57.0706 23.0033V41.275C57.0706 42.2534 56.5471 43.1584 55.7069 43.6476L40.0967 52.7713C39.6706 53.0159 39.1957 53.1382 38.7208 53.1382ZM38.7208 12.8523C38.5382 12.8523 38.3677 12.9012 38.2094 12.9868L22.5993 22.1105C22.2827 22.2939 22.0878 22.6364 22.0878 23.0033V41.275C22.0878 41.6419 22.2827 41.9844 22.5993 42.1678L38.2094 51.2914C38.526 51.4749 38.9278 51.4749 39.2444 51.2914L54.8545 42.1678C55.1711 41.9844 55.3659 41.6419 55.3659 41.275V23.0033C55.3659 22.6364 55.1711 22.2939 54.8545 22.1105L39.2444 12.9991C39.0861 12.9012 38.9035 12.8523 38.7208 12.8523Z",
    fill: "url(#paint11_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2596 29.4729L39.147 18.1846V31.3808L37.2596 29.4729Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.147 18.1846V31.3808L41.3022 29.3751L39.147 18.1846Z",
    fill: "url(#paint12_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1957 28.7148L48.9369 22.9177L38.9766 31.4176L39.1957 28.7148Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9369 22.9177L38.9766 31.4176L41.8745 31.7845L48.9369 22.9177Z",
    fill: "url(#paint13_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7801 29.2773L50.8363 31.6011L37.8319 31.1241L39.7801 29.2773Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8363 31.601L37.8319 31.124L39.7314 33.3744L50.8363 31.601Z",
    fill: "url(#paint14_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.424 30.9773L47.3904 40.7003L38.7573 30.8184L41.424 30.9773Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3904 40.7003L38.7573 30.8184L38.4651 33.7658L47.3904 40.7003Z",
    fill: "url(#paint15_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3145 32.9951L39.1836 44.2346L39.4515 31.0505L41.3145 32.9951Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1835 44.2346L39.4514 31.0505L37.2719 33.0073L39.1835 44.2346Z",
    fill: "url(#paint16_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0481 34.0226L30.0635 39.355L40.3891 31.332L40.0481 34.0226Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0635 39.3549L40.3891 31.332L37.5154 30.8306L30.0635 39.3549Z",
    fill: "url(#paint17_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5398 33.3623L26.4105 31.4544L39.4271 31.4421L37.5398 33.3623Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4105 31.4543L39.4271 31.4421L37.4423 29.2651L26.4105 31.4543Z",
    fill: "url(#paint18_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1394 31.0506L30.4287 21.1687L38.8061 31.2707L36.1394 31.0506Z",
    fill: "#937BE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4287 21.1687L38.8061 31.2707L39.1714 28.3355L30.4287 21.1687Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1714 33.1297C40.1331 33.1297 40.9126 32.3412 40.9126 31.3686C40.9126 30.3959 40.1331 29.6074 39.1714 29.6074C38.2097 29.6074 37.4302 30.3959 37.4302 31.3686C37.4302 32.3412 38.2097 33.1297 39.1714 33.1297Z",
    fill: "url(#paint19_linear_368_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.733 56C37.6859 56 36.6387 55.731 35.7133 55.1806L20.4684 46.2771C18.6298 45.2009 17.4852 43.2074 17.4852 41.0671V23.1867C17.4852 21.0465 18.6298 19.053 20.4684 17.9767L35.7133 9.06099C37.5763 7.97251 39.8898 7.97251 41.7528 9.06099L56.9976 17.9767C58.8363 19.053 59.9809 21.0465 59.9809 23.1867V41.0671C59.9809 43.2074 58.8363 45.2009 56.9976 46.2771L41.7528 55.1806C40.8152 55.731 39.768 56 38.733 56ZM38.733 10.9322C38.1486 10.9322 37.5763 11.0789 37.0649 11.3847L21.82 20.3004C20.7972 20.8997 20.164 22.0004 20.164 23.1867V41.0671C20.164 42.2534 20.7972 43.3541 21.82 43.9534L37.0649 52.8691C38.0999 53.4684 39.3784 53.4684 40.4134 52.8691L55.6461 43.9534C56.6689 43.3541 57.3021 42.2534 57.3021 41.0671V23.1745C57.3021 21.9882 56.6689 20.8875 55.6461 20.2882L40.4012 11.3847C39.8898 11.0789 39.3053 10.9322 38.733 10.9322Z",
    fill: "url(#paint20_linear_368_11)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_11",
    x: 2,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_11",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_368_11",
    x: 0,
    y: 8,
    width: 76.7476,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_11",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_11",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_11",
    x1: 5.21522,
    y1: 25.318,
    x2: 26.3868,
    y2: 19.4615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#887FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#682FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_368_11",
    x1: 5.47518,
    y1: 23.4644,
    x2: 26.5013,
    y2: 22.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#C7BCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#9183D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_368_11",
    x1: 9.95748,
    y1: 32.1764,
    x2: 31.129,
    y2: 26.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#887FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#682FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_368_11",
    x1: 10.2174,
    y1: 30.3228,
    x2: 31.2435,
    y2: 29.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#BBB0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#B53CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_368_11",
    x1: 71.5428,
    y1: 24.7399,
    x2: 50.3712,
    y2: 18.8834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#887FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#682FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_368_11",
    x1: 71.2829,
    y1: 22.8863,
    x2: 50.2568,
    y2: 22.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#C7BCF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#9183D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_368_11",
    x1: 66.8005,
    y1: 31.5982,
    x2: 45.629,
    y2: 25.7417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#887FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#682FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_368_11",
    x1: 66.5406,
    y1: 29.7446,
    x2: 45.5145,
    y2: 29.2221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#BBB0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#B53CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_368_11",
    x1: 38.7701,
    y1: 14.6838,
    x2: 38.5824,
    y2: 54.0762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#F2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ECEAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_368_11",
    x1: 37.3898,
    y1: 20.7014,
    x2: 41.737,
    y2: 55.9776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#C6BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#8774F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_368_11",
    x1: 29.4881,
    y1: 16.0737,
    x2: 48.0843,
    y2: 48.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6952D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2291,
    stopColor: "#8171C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#B1A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    stopColor: "#D5D0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7D2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_368_11",
    x1: 39.1512,
    y1: 24.7866,
    x2: 41.2995,
    y2: 24.7866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_368_11",
    x1: 43.9371,
    y1: 27.1424,
    x2: 45.3685,
    y2: 28.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_368_11",
    x1: 44.3369,
    y1: 31.3597,
    x2: 44.2594,
    y2: 33.5365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_368_11",
    x1: 43.101,
    y1: 35.7404,
    x2: 41.4738,
    y2: 37.1763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_368_11",
    x1: 39.321,
    y1: 37.6407,
    x2: 37.1709,
    y2: 37.5958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_368_11",
    x1: 35.2437,
    y1: 35.3716,
    x2: 33.893,
    y2: 33.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_368_11",
    x1: 32.917,
    y1: 31.4473,
    x2: 32.9149,
    y2: 29.2698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#8676E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5848AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_368_11",
    x1: 38.9548,
    y1: 29.6136,
    x2: 39.3865,
    y2: 33.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4522,
    stopColor: "#A6A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#AB7AF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_368_11",
    x1: 17.2874,
    y1: 31.6357,
    x2: 60.172,
    y2: 32.5967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3128,
    stopColor: "#BFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6369,
    stopColor: "#8B7DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A59D7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.be3f10c218ff136cf7c0c5749bad4bce.svg";
export { ForwardRef as ReactComponent };